/* eslint-disable react/jsx-props-no-spreading, react/prop-types */
import React, { useCallback, useState } from 'react';
import { Button, Overlay } from '@thd-olt-component-react/core-ui';

export const withOverlay = (Component, buttonProps = {}, overlayProps = {}) => (props) => {
  const [open, setOpen] = useState(false);
  const {
    closeButton = true,
    fit = true,
    onToggle
  } = overlayProps;
  const { children } = props;

  const toggleOverlay = useCallback(() => {
    const opened = !open;
    setOpen(opened);
    if (onToggle) {
      onToggle(opened);
    }
  }, [open]);

  return (
    <>
      <Button
        onClick={toggleOverlay}
        {...buttonProps}
      >
        {children}
      </Button>
      {open && (
        <Overlay
          closeButton={closeButton}
          onClose={toggleOverlay}
          scrollable={false}
          open={open}
          fit={fit}
          {...(overlayProps || {})}
        >
          <Component
            {...(props || {})}
            onClose={toggleOverlay}
          />
        </Overlay>
      )}
    </>
  );
};
